import { useState } from 'react';
import { showActionType } from 'config/constants';
import { usePreferences } from 'contexts/PreferencesContext';

function useShowActionModal(action, entity, onContinue, associations = []) {
  const [currentEntity, setCurrentEntity] = useState(null);
  const [previousChoice, setPreviousChoice] = useState(null);
  const [showAction, setShowAction] = useState(null);
  const { preferences } = usePreferences();

  const showModal = preferences[`show_${action}_${entity}_warning`];

  function resetShowAction() {
    setCurrentEntity(null);
    setPreviousChoice(null);
    setShowAction(null);
  }

  // When the user wants to process with the action, what should we do
  function shouldShowAction(data = {}) {
    if (data.entity) setCurrentEntity(data.entity);

    if (showModal) {
      setShowAction(showActionType.PREFERENCE_WARNING);
      return;
    }

    if (associations.length > 0) {
      if (entity === 'employee') setShowAction(showActionType.SHOULD_TRANSFER);
      else setShowAction(showActionType.SELECT_ACTION);
      return;
    }

    onContinue?.();
  }

  function setActionAddress() {
    setShowAction(showActionType.SELECT_ADDRESS);
  }

  function setActionConflictSelect(previousChoice = null) {
    setPreviousChoice(previousChoice);
    setShowAction(showActionType.CONFLICT_SELECT);
  }

  function setActionConflictTransfer(previousChoice) {
    setPreviousChoice(previousChoice);
    setShowAction(showActionType.CONFLICT_TRANSFER);
  }

  function setActionSelect() {
    setShowAction(showActionType.SELECT_ACTION);
  }

  function setActionTransfer() {
    setShowAction(showActionType.SHOULD_TRANSFER);
  }

  return {
    currentEntity,
    previousChoice,
    setActionAddress,
    setActionConflictSelect,
    setActionConflictTransfer,
    setActionSelect,
    setActionTransfer,
    showAction,
    resetShowAction,
    shouldShowAction,
  };
}

export default useShowActionModal;
